<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ flashMessage.message }}
      <v-btn v-if="this.flashMessage.type === 'error'" flat color="red" @click="snackbar = false">Close</v-btn>
      <v-btn v-if="this.flashMessage.type === 'success'" flat color="green" @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <gallery></gallery>
    <navigation v-if="this.$route.meta.requiresAuth === true"></navigation>
    <div class="routes-container">
      <router-view></router-view>
    </div>
    <welcome v-if="authenticated"/>
  </v-app>
</template>

<script >
import Navigation from '@/components/Navigation';
import Gallery from '@/components/Gallery';
import Welcome from '@/components/Welcome';

export default {
  name: 'app',
  components: {
    Navigation,
    Gallery,
    Welcome,
  },
  data() {
    return {
      snackbar: false,
    };
  },
  mounted() {
    if (this.$route.name === 'DirectCompletionQuestions') return;
    if (this.$route.name === 'EmailLogin') return;

    this.$store.dispatch('auth/checkToken', {
      router: this.$router,
      route: this.$route,
    });
    this.$store.dispatch('auth/getUserId');
  },
  computed: {
    authenticated() {
      return this.$store.getters['auth/userToken'];
    },
    flashMessage() {
      const flashMessage = this.$store.getters['auth/flashMessage'];
      if (flashMessage.message) {
        this.snackbar = true;
      }
      return flashMessage;
    },
  },
};
</script>

<style lang="scss">
@import "~styles/shared.scss";
.routes-container {
  width: 100%;
  height: 100%;
}

.centered {
  display: flex;
  justify-content: center;
}

.small-icon {
  transform: scale(0.75);
}
</style>



// WEBPACK FOOTER //
// src/App.vue